import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "count", "maxCount", "maxSuffix"];
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import { GLEAM_STATUS_TYPES } from '../../constants';
import { StyledGleam } from './Gleam.styles';
import { StyledGleamWrapper } from './GleamWrapper.styles';

/**
 * @since 7.39.0
 */
export var Gleam = /*#__PURE__*/forwardRef(function (_ref, forwardedRef) {
  var children = _ref.children,
    count = _ref.count,
    maxCount = _ref.maxCount,
    maxSuffix = _ref.maxSuffix,
    rest = _objectWithoutProperties(_ref, _excluded);
  var value = count;
  if (maxCount && count > maxCount) {
    value = maxCount;
    if (maxSuffix) {
      value += '+';
    }
  }
  var gleam = /*#__PURE__*/React.createElement(StyledGleam, _extends({}, rest, {
    ref: forwardedRef
  }), value);
  if (typeof children !== 'undefined') {
    return /*#__PURE__*/React.createElement(StyledGleamWrapper, null, children, gleam);
  }
  return gleam;
});
Gleam.displayName = 'Gleam';
Gleam.Wrapper = StyledGleamWrapper;
Gleam.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The type of gleam to display.
   */
  appearance: PropTypes.oneOf(Object.values(GLEAM_STATUS_TYPES)),
  /**
   * Postion the gleam relative to the children content.
   */
  children: PropTypes.node,
  /**
   * The notification count displayed on the badge
   */
  count: PropTypes.number.isRequired,
  /**
   * Inverse colors for use on dark or colored backgrounds.
   */
  inverse: PropTypes.bool,
  /**
   * If `count` is greater than `maxCount`, the badge will display `maxCount` instead.
   * You can disable a max by setting this to 0.
   */
  maxCount: PropTypes.number,
  /**
   * If `count` is greater than `maxCount`, the badge will display `maxCount` with a `+` suffix.
   */
  maxSuffix: PropTypes.bool
} : {};
Gleam.defaultProps = {
  appearance: GLEAM_STATUS_TYPES.DEFAULT,
  children: undefined,
  inverse: false,
  maxCount: 99,
  maxSuffix: false
};